/* eslint-disable */
import { CircularProgress } from "@mui/material";
import React from "react";

const GridLoader = () => {
  return (
    <div
      className="d-flex align-items-center justify-content-center h-100"
      style={{ borderTop: "1px solid gray" }}
    >
      <CircularProgress size={25} />
    </div>
  );
};

export default GridLoader;
